const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/service-requests.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/service-requests')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface PendingBooking {
  id: string;
  petId: string | null;
  petName: string;
  petSpecies: string | null;
  petBreed: string | null;
  ownerName: string;
  ownerEmail: string | null;
  ownerPhone: string | null;
  scheduledDate: string;
  scheduledTime: string;
  serviceName: string | null;
  serviceType: string | null;
  serviceCategory: string | null;
  status: string;
  priority: string;
  isEmergency: boolean;
  source: string | null;
  dataShared: string[] | null;
  notes: string | null;
  petDid: string | null;
  petMicrochipId: string | null;
  petGender: string | null;
  petColor: string | null;
  petDateOfBirth: string | null;
  petApproximateAge: string | null;
}